// Service Imports
import {
  checkInboxUnreadNotificationService,
  getColVisibilityList,
  getRbacRoles,
  updateColVisibilityList,
} from "./commonService";

// Method Imports
import { parseColVisiblity } from "./commonMethods";

// Destructuring

// Functions
export const getColVisibility = page => async () => {
  try {
    const rbacRoles = await getRbacRoles();
    const colVisibilityList = await getColVisibilityList(page);

    return Promise.all([rbacRoles, colVisibilityList])
      .then(response => parseColVisiblity(response, page))
      .catch(error => {
        console.debug("commonActions =>", error);
        throw error;
      });
  } catch (error) {
    throw error;
  }
};

export const updateColVisibility = (obj, page) => async () => {
  try {
    const updateList = await updateColVisibilityList(obj, page);
    return updateList;
  } catch (error) {
    throw error;
  }
};

export function changeAuth(isLoggedIn) {
  return { type: "CHANGE_AUTH", payload: isLoggedIn };
}

export function loadOpportunityDetails(opportunityDetails) {
  return { type: "LOAD_OPPORTUNITY_DETAILS", payload: opportunityDetails };
}

export const checkInboxUnreadNotification = () => dispatch =>
  new Promise((resolve, reject) => {
    checkInboxUnreadNotificationService()
      .then(response => {
        if (response.unseen_notifications) {
          dispatch({
            type: "INBOX_SEEN_UNSEEN_NOTIFICATIONS",
            payload: response.unseen_notifications,
          });
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/CommonActions/commonActions.js